import Vue from 'vue'
import Router from 'vue-router'
// import Layout from '@/views/layout'

Vue.use(Router)

export const constantRoutes =
  [
    {
      path: '/',
      name: 'login',
      component: () => import('@/views/login'),
      meta: { title: '登录界面' }
    },
    {
      path: '/password',
      name: 'password',
      component: () => import('@/views/password'),
      meta: { title: '登录界面' }
    },
    {
      path: '/',
      component: () => import(`@/views/layout`),
      children: [{
        path: '/personal',
        name: 'home',
        label: '个人认证',
        component: () => import('@/views/personal'),
        meta: { title: '个人认证' }
      }, {
        path: '/enterprise',
        name: 'enterprise',
        label: '企业认证',
        icon: 'video-play',
        component: () => import('@/views/enterprise')
      },
      {
        path: '/paifang',
        name: 'paifang',
        label: '排放时间管理',
        icon: 'reading',
        component: () => import('@/views/paifang')
      },
      {
        path: '/beyeye',
        name: 'beyeye',
        label: '车辆识别管理',
        icon: 'first-aid-kit',
        component: () => import('@/views/beyeye')
      },
      {
        path: '/log',
        name: 'log',
        label: '日志管理',
        icon: 's-order',
        component: () => import('@/views/log')
      },
      {
        path: '/baimingd',
        name: 'baimingd',
        label: '白名单管理',
        icon: 'reading',
        component: () => import('@/views/baimingd')
      },

      {
        path: '/yuanliao',
        name: 'yuanliao',
        label: '原料记录',
        icon: 'reading',
        component: () => import('@/views/yuanliao')
      },
      {
        path: '/menu',
        name: 'menu',
        label: '菜单管理',
        icon: 'reading',
        component: () => import('@/views/menu')
      },
      {
        path: '/juese',
        name: 'juese',
        label: '角色管理',
        icon: 'reading',
        component: () => import('@/views/juese')
      },
      {
        path: '/caseregistration',
        name: 'caseregistration',
        label: '案件登记',
        icon: 'user',
        component: () => import('@/views/caseregistration')
      },
      {
        path: '/casedealt',
        name: 'casedealt',
        label: '案件办理',
        icon: 'video-play',
        component: () => import('@/views/casedealt')
      },
      {
        path: '/hemingdan',
        name: 'hemingdan',
        label: '黑名单管理',
        icon: 's-order',
        component: () => import('@/views/hemingdan')
      },
      {
        path: '/litiji',
        name: 'litiji',
        label: '立体机管理',
        icon: 'reading',
        component: () => import('@/views/litiji')
      },
      {
        path: '/xianzhong',
        name: 'xianzhong',
        label: '限重管理',
        icon: 'setting',
        component: () => import('@/views/xianzhong')
      },
      {
        path: '/video',
        name: 'video',
        label: '结案记录',
        icon: 'video-play',
        component: () => import('@/views/jienajilu')
      },
      {
        path: '/zhaungchedian',
        name: 'zhaungchedian',
        label: '装车点',
        icon: 'video-play',
        component: () => import('@/views/zhaungchedian')
      },
      {
        path: '/chezhou',
        name: 'chezhou',
        label: '车轴管理',
        icon: 'reading',
        component: () => import('@/views/chezhou')
      },
      {
        path: '/shixiao',
        name: 'shixiao',
        label: '二维码失效管理',
        icon: 'first-aid-kit',
        component: () => import('@/views/shixiao')
      },
      {
        path: '/liucheng',
        name: 'liucheng',
        label: '流程管理',
        icon: 'first-aid-kit',
        component: () => import('@/views/liucheng')
      },
      {
        path: '/bangzu',
        name: 'bangzu',
        label: '帮助说明',
        icon: 'video-play',
        component: () => import('@/views/bangzu')
      }, {
        path: '/ameagger',
        name: 'ameagger',
        label: '管理员',
        icon: 'video-play',
        component: () => import('@/views/ameagger')
      },
      {
        path: '/shenheren',
        name: 'shenheren',
        label: '审核人',
        icon: 'video-play',
        component: () => import('@/views/shenheren')
      }]
    },
    {
      path: '/error',
      name: 'error',
      component: () => import('@/views/error'),
      meta: { title: '错误界面' }
    }
  ]
const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  })

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js